import type { HttpPatch } from '@/shared/infra/http'
import type { RenameChannel } from '@/modules/connect/use-cases'
import { mapChannelAdminError } from './map-channel-admin-error'
import { type ChannelDto, toChannel } from './channel-dto'

type RenameChannelResponseDto = {
  channel: ChannelDto
}

export class EdgeRenameChannelRepository {
  constructor(private readonly http: HttpPatch) {}

  execute: RenameChannel = async (params) => {
    try {
      const data = await this.http.patch<unknown, RenameChannelResponseDto>({
        url: `/connect/channels/${encodeURIComponent(params.channelId)}`,
        body: {
          orgId: params.orgId,
          orgType: params.orgType,
          name: params.name,
          ...(params.color ? { color: params.color } : {}),
        },
      })
      return { channel: toChannel(data.channel) }
    } catch (err) {
      throw mapChannelAdminError(err)
    }
  }
}
